import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

const QtCategoryName = (props) => {

  const {qtCategoryName, intl, fabricatorData} = props;

  return getQtCategoryName(qtCategoryName, intl, fabricatorData)
};

QtCategoryName.propTypes = {
  qtCategoryName: PropTypes.string,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(QtCategoryName)
)

export const getQtCategoryName = (qtCategoryName, intl, fabricatorData) => {
  if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && intl.messages) {
    if (intl.locale === "fr-FR" && intl.messages["transDoc.customDisplayName_FR." + qtCategoryName]) {
      return intl.formatMessage({id: "transDoc.customDisplayName_FR."  + qtCategoryName})
    } else if (intl.locale === "pl-PL" && intl.messages["transDoc.customTranslateName_PL." + qtCategoryName]) {
      return intl.formatMessage({id: "transDoc.customTranslateName_PL."  + qtCategoryName})
    }
  }

  return qtCategoryName
}
